import { render, staticRenderFns } from "./cover-upload-release.vue?vue&type=template&id=50b80d09&"
import script from "./cover-upload-release.vue?vue&type=script&lang=js&"
export * from "./cover-upload-release.vue?vue&type=script&lang=js&"
import style0 from "./cover-upload-release.vue?vue&type=style&index=0&id=50b80d09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports